<form class="integration-form" [ngClass]="{'was-validated': frm.submitted}"
      novalidate #frm="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-card">
    <div class="form-brand">
      <span class="ifood-mark"><img src="/assets/icons/logo-ifood.png" alt="iFood"></span>
      <div>
        <h3>{{integracaoIfood.nomeLoja || 'Integração centralizada'}}</h3>
        <p>Revise as APIs e a configuração desta integração iFood.</p>
      </div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">{{mensagemErro}}</div>

    <section class="current-integration">
      <div>
        <small>Merchant ID</small>
        <strong>{{integracaoIfood.idLoja}}</strong>
      </div>
      <div>
        <small>Ativada em</small>
        <strong>{{integracaoIfood.dataAtivacao | date: 'dd/MM/yyyy'}}</strong>
      </div>
      <div>
        <small>Token válido até</small>
        <strong>{{integracaoIfood.validadeToken ? (integracaoIfood.validadeToken | date: 'dd/MM/yyyy HH:mm') : '—'}}</strong>
      </div>
    </section>

    <section class="form-section">
      <div class="section-heading">
        <span class="step-number">1</span>
        <div><h4>APIs da integração</h4><p>Confira as APIs disponíveis para esta integração.</p></div>
      </div>

      <article class="service-option catalog-service" [class.enabled]="catalogApiAtiva()">
        <div class="catalog-api-row">
          <span class="service-icon"><i class="fas fa-cube"></i></span>
          <div class="service-copy">
            <strong>Catalog API</strong>
            <small>Permite consultar e manter o catálogo da loja no iFood.</small>
          </div>
          <span class="service-status" [class.disabled]="!catalogApiAtiva()">
            {{catalogApiAtiva() ? 'Ativa' : 'Inativa'}}
          </span>
        </div>

        <div class="catalog-publication-control" *ngIf="catalogApiAtiva()"
             [class.enabled]="integracaoIfood.publicacaoCatalogoHabilitada">
          <span class="publication-control-icon"><i class="fas fa-upload"></i></span>
          <div class="service-copy">
            <strong>Publicação de catálogo</strong>
            <small>Habilita publicação, pausa e atualização de produtos, categorias e adicionais no iFood pelo catálogo do Meu Cardápio.</small>
          </div>
          <kendo-switch name="publicacaoCatalogoHabilitada"
                        [(ngModel)]="integracaoIfood.publicacaoCatalogoHabilitada"
                        [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
        </div>
      </article>
    </section>

    <footer class="form-actions">
      <button class="btn btn-light" type="button" (click)="cancelar()" [disabled]="salvando">Cancelar</button>
      <button class="btn btn-primary" type="submit" [disabled]="salvando">
        <i class="fas fa-spinner fa-spin mr-1" *ngIf="salvando"></i>Salvar alterações
      </button>
    </footer>
  </div>
</form>
